import * as Combobox from '@givebutter/primitives/combobox';
import { PledgeStatus } from 'constants/pledges';

const PledgeStatusOptions = () => (
    <>
        <Combobox.Item value={PledgeStatus.Fulfilled}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Fulfilled</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={PledgeStatus.Canceled}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Canceled</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={PledgeStatus.OnSchedule}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>On schedule</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={PledgeStatus.OffSchedule}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Off schedule</Combobox.ItemText>
        </Combobox.Item>
    </>
);

export { PledgeStatusOptions };
